module.exports = __webpack_public_path__ + "static/media/userProfileError.14e243fb.svg";